import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Import } from 'lucide-react'
import { IngestionScreen } from '@/screens/connect/SCR-036-ingestion'

const flag = z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean())

export const Route = createFileRoute('/_app/connect/ingestion')({
  staticData: { screen: { id: 'SCR-036', title: 'Ingestion runs', group: 'Connect', perm: 'connector.manage', order: 3, description: 'Every sync, webhook batch and import: what it captured, what failed and why. Retry failed items.', icon: Import } },
  validateSearch: z.object({
    source: z.string().max(100).optional().catch(undefined),
    import: z.string().max(100).optional().catch(undefined),
    kind: z.enum(['webhook', 'sync', 'test', 'import', 'undo', 'erase', 'retry']).optional().catch(undefined),
    status: z.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']).optional().catch(undefined),
    problems: flag.optional().catch(undefined),
    run: z.string().max(100).optional().catch(undefined),
  }),
  component: IngestionScreen,
})
